import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {TipoCFEDTO} from '../../../models/dtos/TipoCFEDTO';
import {FormaPagoDTO} from '../../../models/dtos/FormaPagoDTO';
import {IdentificacionCFEDTO} from '../../../models/dtos/IdentificacionCFEDTO';
import {AbstractControl, FormGroup} from '@angular/forms';
import {DatosInicioIdentificacionDTO} from '../../../models/dtos/datosInicio/DatosInicioIdentificacionDTO';
import {
  COD_TIPO_CFE_E_FACTURA_EXP,
  COD_TIPO_CFE_NOTA_CREDITO_E_FACTURA_EXP, COD_TIPO_CFE_NOTA_DEBITO_E_FACTURA_EXP
} from '../../../constants/ConstantesTipoCFE';

@Component
({
  selector: 'app-identificacion',
  templateUrl: './identificacion.component.html',
  styleUrls: ['./identificacion.component.scss']
})
export class IdentificacionComponent implements OnInit
{
  @Input()
  identificacionCFEDTO: IdentificacionCFEDTO;

  @Input()
  datosInicioIdentificacionDTO: DatosInicioIdentificacionDTO;

  @Input()
  parentFormGroup: FormGroup;

  @Output()
  cambioEnTipoCFEEvent: EventEmitter<TipoCFEDTO> = new EventEmitter<TipoCFEDTO>();

  constructor()
  {

  }

  ngOnInit()
  {
    this.datosInicioIdentificacionDTO.tiposCFEsDTOs.sort((a: TipoCFEDTO, b: TipoCFEDTO) => {
      if (a.codigo < b.codigo) {
        return -1;
      } else if (a.codigo > b.codigo) {
        return 1;
      } else {
        return 0;
      }
    });
  }

  get tipoCFEControl(): AbstractControl
  {
    return this.parentFormGroup.get('tipoCFEControl');
  }

  get serieControl(): AbstractControl
  {
    return this.parentFormGroup.get('serieControl');
  }

  get numeroControl(): AbstractControl
  {
    return this.parentFormGroup.get('numeroControl');
  }

  get fechaEmisionControl(): AbstractControl
  {
    return this.parentFormGroup.get('fechaEmisionControl');
  }

  get formaPagoControl(): AbstractControl
  {
    return this.parentFormGroup.get('formaPagoControl');
  }

  get clausulaVentaControl(): AbstractControl
  {
    return this.parentFormGroup.get('clausulaVentaControl');
  }

  get modalidadVentaControl(): AbstractControl
  {
    return this.parentFormGroup.get('modalidadVentaControl');
  }

  get viaTransportacionControl(): AbstractControl
  {
    return this.parentFormGroup.get('viaTransportacionControl');
  }

  private obtenerTipoCFE(codigoTipoCFE: number): TipoCFEDTO
  {
    let tipoCFEARetornarDTO: TipoCFEDTO = null;
    for (const tipoCFEDTO of this.datosInicioIdentificacionDTO.tiposCFEsDTOs)
    {
      if (tipoCFEDTO.codigo === codigoTipoCFE)
      {
        tipoCFEARetornarDTO = tipoCFEDTO;
        break;
      }
    }

    return tipoCFEARetornarDTO;
  }

  private obtenerFormaPago(codigoFormaPago: number): FormaPagoDTO
  {
    let formaPagoARetornarDTO: FormaPagoDTO = null;
    for (const formaPagoDTO of this.datosInicioIdentificacionDTO.formasPagosDTOs)
    {
      if (formaPagoDTO.codigo === codigoFormaPago)
      {
        formaPagoARetornarDTO = formaPagoDTO;
        break;
      }
    }

    return formaPagoARetornarDTO;
  }

  public onTipoCFEChange(): void
  {
    this.identificacionCFEDTO.tipoCFE = this.obtenerTipoCFE(this.datosInicioIdentificacionDTO.codigoTipoCFESeleccionado);
    this.cambioEnTipoCFEEvent.emit(this.identificacionCFEDTO.tipoCFE);
  }

  public onFormaPagoChange(): void
  {
    this.identificacionCFEDTO.formaPago = this.obtenerFormaPago(this.datosInicioIdentificacionDTO.codigoFormaPagoSeleccionada);
  }

  esFactExp() {
    if (this.identificacionCFEDTO.tipoCFE) {
      return this.identificacionCFEDTO.tipoCFE.codigo === COD_TIPO_CFE_E_FACTURA_EXP || this.identificacionCFEDTO.tipoCFE.codigo === COD_TIPO_CFE_NOTA_CREDITO_E_FACTURA_EXP || this.identificacionCFEDTO.tipoCFE.codigo === COD_TIPO_CFE_NOTA_DEBITO_E_FACTURA_EXP;
    } else {
      return false;
    }
  }
}
